const placementSettings = {
  "sk8-hi": {
    "quarters": {
      "noWarp": {
        "x": 0,
        "y": 0,
        "width": 717,
        "height": 582
      },
      "bulge": {
        "x": 0,
        "y": 290,
        "width": 1024,
        "height": 832
      },
      "pinch": {
        "x": 50,
        "y": 145,
        "width": 1024,
        "height": 832
      },
      "crazyWarp": {
        "x": 0,
        "y": 145,
        "width": 1024,
        "height": 832
      }
    }
  },
  "slip-on-classic": {
    "vamp": {
      "noWarp": {
        "x": 0,
        "y": 0,
        "width": 1024,
        "height": 877
      },
      "bulge": {
        "x": 0,
        "y": 150,
        "width": 1024,
        "height": 877
      },
      "pinch": {
        "x": 0,
        "y": 50,
        "width": 1024,
        "height": 877
      },
      "crazyWarp": {
        "x": 0,
        "y": 50,
        "width": 1024,
        "height": 877
      }
    }
  },
  "authentic-classic": {
    "vamp": {
      "noWarp": {
        "x": 0,
        "y": 0,
        "width": 1024,
        "height": 809
      },
      "bulge": {
        "x": 0,
        "y": 380,
        "width": 1024,
        "height": 809
      },
      "pinch": {
        "x": 12,
        "y": 80,
        "width": 1024,
        "height": 809
      },
      "crazyWarp": {
        "x": 25,
        "y": 170,
        "width": 1024,
        "height": 809
      }
    },
    "quarters": {
      "noWarp": {
        "x": 0,
        "y": 0,
        "width": 1024,
        "height": 384
      },
      "bulge": {
        "x": 0,
        "y": 450,
        "width": 1024,
        "height": 384
      },
      "pinch": {
        "x": 0,
        "y": 250,
        "width": 1024,
        "height": 384
      },
      "crazyWarp": {
        "x": 0,
        "y": 50,
        "width": 1024,
        "height": 384
      }
    }
  },
  "era-classic": {
    "vamp": {
      "noWarp": {
        "x": 0,
        "y": 0,
        "width": 1024,
        "height": 748
      },
      "bulge": {
        "x": 0,
        "y": 280,
        "width": 1024,
        "height": 748
      },
      "pinch": {
        "x": 0,
        "y": 50,
        "width": 1024,
        "height": 748
      },
      "crazyWarp": {
        "x": 5,
        "y": 50,
        "width": 1024,
        "height": 748
      }
    }
  },
  "old-skool-classic": {
    "quarters": {
      "noWarp": {
        "x": 0,
        "y": 0,
        "width": 1024,
        "height": 384
      },
      "bulge": {
        "x": 0,
        "y": 450,
        "width": 1024,
        "height": 384
      },
      "pinch": {
        "x": 0,
        "y": 250,
        "width": 1024,
        "height": 384
      },
      "crazyWarp": {
        "x": 0,
        "y": 50,
        "width": 1024,
        "height": 384
      }
    }
  },
  "backpack": {
    "front": {
      "noWarp": {
        "x": 0,
        "y": 0,
        "width": 783,
        "height": 984
      },
      "bulge": {
        "x": 50,
        "y": -10,
        "width": 783,
        "height": 984
      },
      "pinch": {
        "x": 255,
        "y": 505,
        "width": 783,
        "height": 984
      },
      "crazyWarp": {
        "x": 100,
        "y": 25,
        "width": 783,
        "height": 984
      }
    }
  },
  "slip-on-classic-platform": {
    "vamp": {
      "noWarp": {
        "x": 0,
        "y": 0,
        "width": 1024,
        "height": 877
      },
      "bulge": {
        "x": 0,
        "y": 150,
        "width": 1024,
        "height": 877
      },
      "pinch": {
        "x": 0,
        "y": 50,
        "width": 1024,
        "height": 877
      },
      "crazyWarp": {
        "x": 0,
        "y": 50,
        "width": 1024,
        "height": 877
      }
    }
  },
  "old-skool-classic-platform": {
    "quarters": {
      "noWarp": {
        "x": 0,
        "y": 0,
        "width": 1024,
        "height": 384
      },
      "bulge": {
        "x": 0,
        "y": 450,
        "width": 1024,
        "height": 384
      },
      "pinch": {
        "x": 0,
        "y": 250,
        "width": 1024,
        "height": 384
      },
      "crazyWarp": {
        "x": 0,
        "y": 50,
        "width": 1024,
        "height": 384
      }
    }
  }
};
export {
  placementSettings
}
